import { Component, OnInit } from '@angular/core';

import { ROUTES_CONFIG } from '@ib-core/config/routes.config';
import { UiBreakpointsService } from '@ib-core/services/ui-breakpoints.service';
import { UiSidebarService } from '@ib-core/services/ui-sidebar.service';
import { AnimationOpacityIn300ms } from '@ib-shared/animations/in-opacity-300ms.anim';
import { IRouteItem } from 'src/app/core/interfaces/route-item.intf';

@Component({
  selector: 'ib-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  animations: [AnimationOpacityIn300ms],
})
export class NavComponent implements OnInit {
  public routeItems: Array<IRouteItem> = ROUTES_CONFIG;
  public isSidebarExpanded$ = this.sidebarS.selectIsSidebarExpanded();

  public isAnimDisabled = true;

  constructor(
    public sidebarS: UiSidebarService,
    public bpS: UiBreakpointsService,
  ) {}
  ngOnInit(): void {
    setTimeout(() => {
      this.isAnimDisabled = false;
    }, 300);
  }

  closeMenu(): void {
    this.sidebarS.toggleSidebar();
  }
}
